/**** mgt.Department */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Department',
  title: 'Территориальные отделы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    depots: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    }
  },
  fields: [
    {
      name: 'td_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'td_name',
      title: 'Наименование',
      type: 'text',
      required: true
    },
    {
      name: 'td_adress',
      title: 'Адрес',
      type: 'text',
      required: true,
    },
    {
      name: 'td_phone',
      title: 'Номер телефона',
      type: 'text',
      required: false
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'depots',
    },
    {
      name: 'td_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'td_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      title: 'Координаты',
      type: 'composite',
      composite: {
        type: 'point_coords',
        lat: 'td_lat',
        lon: 'td_lon',
      },
    },
    {
      name: 'td_color',
      title: 'Цвет на карте',
      type: 'color'
    }
  ],
  newTemplate: {
    td_id: null,
    td_name: '',
    td_adress: '',
    td_phone: '',
    depot_id: null,
    td_lat: null,
    td_lon: null,
    td_color: "#000000"
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'td_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'td_id',
        field: 'td_id',
      },{
        title: 'td_name',
        field: 'td_name',
      },{
        title: 'td_adress',
        field: 'td_adress',
      },{
        title: 'td_phone',
        field: 'td_phone',
      },{
        title: 'depot_id',
        field: 'depot_id',
      },{
        title: 'td_lat',
        field: 'td_lat',
      },{
        title: 'td_lon',
        field: 'td_lon',
      }
    ],
    example: `1;Название;Адрес;88003000600;1;59.918077;30.304900`,
  }


};

export default config;